"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Profile/Modals/AvatarPicker/Form/DefaultAvatarsList/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _const = require('./const');
var _keyboard = require('web/services/keyboard');






const DefaultAvatarsList = ({
  onSubmit,
  onUploadCustom,
}) => (
  _react2.default.createElement('div', { className: "avatar-picker", __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}
    , _react2.default.createElement('div', {
      role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
      onClick: onUploadCustom,
      className: "avatar-picker--option avatar-picker--option--custom" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}

      , _react2.default.createElement('img', {
        src: "/assets/icons/ext-link-grey.svg",
        className: "avatar-picker--option--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}
      )
      , _react2.default.createElement('span', { className: "avatar-picker--option--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}, "Upload")
    )
    ,  Object.keys(_const.defaultAvatars)
      .map(k => {
        const ref = _const.defaultAvatars[k ]
        return (
          _react2.default.createElement('div', {
            role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
            key: k,
            className: "avatar-picker--option",
            onClick: () => onSubmit(ref), __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}

            , _react2.default.createElement('img', {
              src: ref,
              className: "avatar-picker--preview",
              alt: k, __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
            )
          )
        )
      })
    
  )
)

exports. default = DefaultAvatarsList
